<div class="shell">
  <div class="shell__col-left">
    <spark-sidebar-nav [items]="mainMenuItems"></spark-sidebar-nav>
  </div>

  <div class="shell__col-right">
    <div class="shell__header">
      <spark-appbar></spark-appbar>
    </div>

    <!-- content pane -->
    <div role="main" class="shell__content">
      <div class="w-100">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
